import { dataCalendarHeart } from 'dls-icons-data'
import { createIcon } from '../common'

const IconCalendarHeart = /*#__PURE__*/createIcon(dataCalendarHeart)
export default IconCalendarHeart
